import { render, staticRenderFns } from "./CaseDetails.vue?vue&type=template&id=685e3565&scoped=true&"
import script from "./CaseDetails.vue?vue&type=script&lang=ts&"
export * from "./CaseDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CaseDetails.vue?vue&type=style&index=0&id=685e3565&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e3565",
  null
  
)

export default component.exports